<script>
/**
 * Unlocked fork: this used to be the premium/enterprise upsell modal (feature
 * comparison + "view pricing" link to baserow.io). Every feature is unlocked
 * here, so nothing can trigger it and it renders nothing.
 *
 * It is kept as an inert stub rather than deleted because ~37 registry files
 * and components still reference it as a template child and call `.show()` on
 * a `$refs` handle. Keeping the prop / show() / hide() contract means those
 * call sites need no changes and stay diffable against upstream.
 *
 * The stub deliberately has **no `<template>` block**. An empty template (or one
 * holding only a comment) has no root element, which `vue/valid-template-root`
 * rejects and which leaves the component without a usable render function. An
 * explicit `render()` returning `null` is the supported way to say "render
 * nothing": Vue treats a `null` return as an empty vnode, whereas an
 * `undefined` return warns and can break the parent's patch.
 */
export default {
  name: 'PaidFeaturesModal',
  props: {
    workspace: {
      type: [Object, null],
      required: false,
      default: null,
    },
    initialSelectedType: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    show() {},
    hide() {},
  },
  render() {
    return null
  },
}
</script>
